import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";

import logomodel from "./Scenes assets/Fxscene4/scene.gltf";
import { running } from "animejs";
let scene, camera;
let logo, clock;
let scrollPercent;

function fullscene(scene, camera, animations) {
  this.scene = scene;
  this.camera = camera;
  this.animations = animations;
}

export default function Logo(
  renderer,
  loadingmanager,
  animationScripts,
  scrollPercent
) {
  function init() {
    const loader = new GLTFLoader(loadingmanager);
    const width = window.innerWidth,
      height = window.innerHeight;
    camera = new THREE.PerspectiveCamera(70, width / height, 0.01, 10);
    camera.position.z = 3;
    scene = new THREE.Scene();
    clock = new THREE.Clock();
    loader.load(logomodel, function (gltf) {
      scene.add(gltf.scene);
      logo = gltf.scene;
    });

    function lerp(x, y, a) {
      return (1 - a) * x + a * y;
    }

    // Used to fit the lerps to start and end at specific scrolling percentages
    function scalePercent(start, end) {
      return (scrollPercent - start) / (end - start);
    }

    animationScripts.push({
      start: 0,
      end: 5,

      func: () => {
        camera.position.y = lerp(0, 1, scalePercent(0, -1));
        
        if (logo) {
          const delta = clock.getDelta();
          logo.rotation.y += 0.1 * delta;
        }
      },
    });


  }
  animationScripts.push({
    start: 0,
    end: 100,

    func: () => {
      scrollPercent =
        ((document.documentElement.scrollTop || document.body.scrollTop) /
          ((document.documentElement.scrollHeight ||
            document.body.scrollHeight) -
            document.documentElement.clientHeight)) *
        100;
  

    },
    
  });

  function animate() {
    requestAnimationFrame(animate);

  }

  init();
  animate();
  let block = new fullscene(scene, camera);
  return block;
}
